<rt-form-field [required]="!control().value">
  <rt-label>{{ 'app.interview.template' | translate }}</rt-label>

  <rt-select
    [formControl]="control()"
    [hasInputTrigger]="true"
    [groupedOptions]="groupedForms()"
    [disabled]="disabled()"
    [includeEmptyOption]="false"
    [searchPlaceholder]="'app.common.placeholders.search.forms.other' | translate"
    [placeholder]="'app.interview.template_placeholder' | translate"
    [optionTemplate]="defaultOptionTemplate"
  />

  <ng-template #defaultOptionTemplate let-option="option">
    <div>
      <span margin-right-small-x>{{ option.label }}</span>
      @if (option.badgeText) {
        <rt-badge [text]="option.badgeText" color="optional" flex />
      }
    </div>
  </ng-template>
</rt-form-field>
